import {Component, OnInit} from '@angular/core';
import {Emitters} from '../../helpers/core/emitters';
import {HttpRequests} from '../../helpers/core/http.requests';
import {CommonFunctions} from '../../helpers/core/common.functions';

@Component({
    selector: 'app-delete',
    templateUrl: './delete.component.html'
})
export class DeleteComponent implements OnInit {
    public title: string;
    private url: string;
    private callBackData;
    private callBackKey: string;

    constructor(private c_f: CommonFunctions, private emitters: Emitters, private h_r: HttpRequests) {
    }

    ngOnInit() {
        this.callBackData = {};
    }

    public OpenedModel(title, url, callBackKey = 'remove') {
        this.title = title;
        this.url = url;
        this.callBackKey = callBackKey;
    }

    public ConfirmedDeleteItem() {
        this.callBackData[this.callBackKey] = true;
        this.h_r.HttpDelete(this.url).subscribe(response => {
            if (response.status) {
                this.emitters.change(this.callBackData);
                this.c_f.ShowToast(response.message, 'success');
            } else {
                this.c_f.ShowToast(response.message, 'danger');
            }
            this.c_f.CloseModel('delete-model-popup');
            this.c_f.setLoading(false);
        });
    }
}
